/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Heading_1Inputs */

const et_faq_heading_1 = /** @type {(inputs: Faq_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korduma kippuvad`)
};

const en_faq_heading_1 = /** @type {(inputs: Faq_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked`)
};

/**
* | output |
* | --- |
* | "Frequently Asked" |
*
* @param {Faq_Heading_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_heading_1 = /** @type {((inputs?: Faq_Heading_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Heading_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_heading_1(inputs)
	return en_faq_heading_1(inputs)
});